import React, { createContext, useContext, useState, useEffect } from 'react';

interface ChecklistContextType {
  completionPercentage: number;
  setCompletionPercentage: (value: number) => void;
}

const ChecklistContext = createContext<ChecklistContextType | undefined>(undefined);

export const ChecklistProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  const [completionPercentage, setCompletionPercentage] = useState(0);
  
  

  return (
    <ChecklistContext.Provider value={{ completionPercentage, setCompletionPercentage }}>
      {children}
    </ChecklistContext.Provider>
  );
};

export const useChecklist = () => {
  const context = useContext(ChecklistContext);
  if (!context) {
    throw new Error('useChecklist must be used within a ChecklistProvider');
  }
  return context;
};